import React from 'react';
import PropTypes from 'prop-types';

const CardBlog = ({ LinkImage, Title, Description, url }) => (
    <article className="blog-presentation">
    
        <img src={LinkImage} alt={Title} />
    
        <section className="content-text-presentation">
            <a href={`/blog/post/${url}`} ><h2>{Title}</h2></a>
            <p> {Description} </p>
        </section>
    
    </article>
)

CardBlog.propTypes = {
    LinkImage: PropTypes.string,
    Title: PropTypes.string,
    Description: PropTypes.string
}
CardBlog.defaultProps = {
    LinkImage: "https://cdn.pixabay.com/photo/2016/10/25/23/54/not-found-1770320_960_720.jpg",
    Title: "Title",
    Description: "Description"
}

export default CardBlog;
